export default function handleAccordionBlocks() {
    let $accordion = $('.js-accordion');

    if ($accordion.length > 0) {
        $('body').on('click', '.js-accordion-btn', function () {
            let $parent = $(this).parent('.js-accordion');
            $parent.toggleClass('accordion--active');
            $parent.find('.accordion__body').stop().slideToggle({
                start: function () {
                    $(this).css('display', 'flex');
                }
            });
        });
    }
}